import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import '@grandvisionhq/common';
import '@grandvisionhq/state';
import { ServiceStoreContainer } from '../containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '../../../StepShipping/selectors.js';

const ServiceStore = /*#__PURE__*/ React.memo((props)=>/*#__PURE__*/ React.createElement(ServiceStoreContainer, swcHelpers.extends({}, props))
);

export { ServiceStore };
//# sourceMappingURL=ServiceStore.js.map
